import { LOAD_CREDENTIALS, CREATE_CREDENTIALS, UPDATE_CREDENTIALS } from "../actions/settings";
import _ from 'lodash';

export default function (state = [], action) {
    switch (action.type) {
        case LOAD_CREDENTIALS:
            return action.payload;            
        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/reducers/settings.js